import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.sort.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions } from 'vuex';
import SettingFieldTable from '@/views/mixin/SettingFieldTable';
import MesTable from '@/api/MesTable/index.js';
import fastSearch from '@/components/fast-search';
import util from '@/libs/util';
import { ExportListData, DeleteOneById, LoadData } from '@/api/DeliveryCode';
import store from '@/store/index';
var mesTable = MesTable('DnBarcode/LoadData');
export default {
  mixins: [SettingFieldTable({
    defaultLoadDataApi: function defaultLoadDataApi(e) {
      return mesTable.LoadData(e);
    }
  })],
  components: {
    fastSearch: fastSearch
  },
  data: function data() {
    return {
      mainTable: [],
      code: '',
      formData: {
        Page: 1,
        // 当前页
        Limit: 10,
        // 分页大小
        LIST_ROUTE: store.getters.routerPath,
        Data: {
          VENDOR_CODE: util.getVENDOR_CODE(),
          ORGANIZE_ID: util.cookies.get('ORG_ID') // Code: '',
          // BillTypeIds: [199694499110981]

        }
      },
      pageInfo: {
        TotalCount: 1,
        PageSize: 10,
        PageIndex: 1
      },
      loading: false,
      times: []
    };
  },
  created: function created() {
    this.getLoadData();
  },
  mounted: function mounted() {//   this.Bus.on('onHandleBlack_OuterBoxLabelManagement',()=>{
    //     this.getLoadData()
    //     this.setOrderStatu('listShow')
    //   })
  },
  methods: _objectSpread(_objectSpread({}, mapActions('DeliveryNote/DeliveryCode', ['setOrderStatu'])), {}, {
    // 日期选择
    handleDate: function handleDate() {
      if (this.times !== null) {
        this.formData.Data.START_TIME = this.times[0];
        this.formData.Data.END_TIME = this.times[1];
        this.getLoadData();
      } else {
        this.formData.Data.START_TIME = null;
        this.formData.Data.END_TIME = null;
        this.getLoadData();
      }
    },
    // 搜索
    search: function search() {
      this.formData.Page = this.pageInfo.PageIndex;
      this.getLoadData();
    },
    handelDelete: function handelDelete(row) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.$confirm('确定要删除?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  var res;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return DeleteOneById(row.ID);

                        case 2:
                          res = _context.sent;

                          if (res.code === 0) {
                            _this.$message.success('删除成功');

                            _this.getLoadData();
                          } else {
                            _this.$message.warning(res.message);
                          }

                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }))).catch(function () {
                  _this.$message.warning('已取消');
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 选择页size
    handleSizeChange: function handleSizeChange(size) {
      this.formData.Limit = size;
      this.getLoadData();
    },
    // 选择页码
    handleCurrentChange: function handleCurrentChange(index) {
      this.formData.Page = index;
      this.getLoadData();
    },
    // 点击导出
    handelExportListData: function handelExportListData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return ExportListData(_this2.formData);

              case 2:
                res = _context3.sent;
                console.log('导出res', res);

                if (res.code === 0) {
                  window.open(_this2.$store.getters.getVUE_APP_DOWN + res.data);
                } else {
                  _this2.$message.warning('导出失败');
                }

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 点击送货单
    handleDELIVERY_NO: function handleDELIVERY_NO(row) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var params, res, ts;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // console.log('this.mainTable',this.mainTable);
                // console.log('row',row);
                params = {
                  Page: 1,
                  Limit: 999,
                  Data: {
                    ORGANIZE_ID: util.cookies.get('ORG_ID'),
                    VENDOR_CODE: util.getVENDOR_CODE(),
                    DELIVERY_NO: row.DELIVERY_NO
                  }
                };
                _context4.next = 3;
                return LoadData(params);

              case 3:
                res = _context4.sent;

                // console.log('res',res);
                if (res.code === 0) {
                  if (res.data.Items.length > 0) {
                    ts = res.data.Items;
                    ts.forEach(function (v) {
                      v.ts = Date.parse(new Date(v.CREATETIME));
                    });
                    ts.sort(function (a, b) {
                      return b.ts - a.ts;
                    }); // console.log('ts',ts);

                    if (row.ID === ts[0].ID) {
                      _this3.setOrderStatu('orderShow');

                      _this3.$emit('onHandleOrderNum', row);
                    } else {
                      _this3.$confirm("\u5F53\u524D\u5373\u5C06\u6253\u5F00\u7684\u9001\u8D27\u5355\uFF1A".concat(row.DELIVERY_NO, "\uFF0C\u4E0D\u662F\u6700\u65B0\u7684\u6570\u636E\uFF0C\u8BF7\u95EE\u662F\u5426\u7EE7\u7EED\u6253\u5F00?"), '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                      }).then(function () {
                        _this3.setOrderStatu('orderShow');

                        _this3.$emit('onHandleOrderNum', row);
                      }).catch(function () {});
                    }
                  }
                } // this.setOrderStatu('orderShow')
                // this.$emit('onHandleOrderNum', row)
                // let index = this.mainTable.findIndex(v=>{
                //     return v.ID === row.ID
                // })
                // this.$nextTick(function () {
                //     this.Bus.emit('onClickDeliveryCodeDELIVERY_NO',row)
                // })


              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 新增外箱标签打码订单
    handelAddBtn: function handelAddBtn() {
      this.setOrderStatu('addOrder');
    },
    // 获取表格数据
    getLoadData: function getLoadData() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this4.loading = true;
                _context5.next = 3;
                return mesTable.LoadData(_this4.formData);

              case 3:
                res = _context5.sent;
                _this4.loading = false;
                console.log('内箱标签表格数据 res', res);

                if (res.code === 0) {
                  _this4.mainTable = res.data.Items;
                  _this4.pageInfo.TotalCount = res.data.TotalCount;
                  _this4.pageInfo.PageIndex = res.data.PageIndex;
                } else {
                  _this4.$message.warning(res.message);
                }

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    fastSearch: function fastSearch(searchData) {
      console.log('searchData', searchData);
      this.formData.ParamList = this.mergeParamList(searchData.ParamList, this.formData.ParamList); // this.formData.ParamList = this.mergeParamList(searchData.ParamList, this.formData.ParamList)

      this.getLoadData();
    }
  })
};